import { ownDatasources, type DemoLike } from "./demo-preference";

type InviteLike = DemoLike & { viewerRole?: string };

/**
 * MOSA-695 item 9. The first page keeps one action: connect a sheet. Inviting
 * a teammate needs a panel to invite them to, so the card stays hidden until
 * the user owns a source. The shared sample does not count — nobody is invited
 * to a read-only demo — and an invited member cannot invite anyone.
 */
export function showsInviteTeammate(args: {
  datasources: InviteLike[] | undefined;
  /** True only while the first source list request has not settled. */
  isInitialLoad: boolean;
}): boolean {
  const { datasources, isInitialLoad } = args;
  if (isInitialLoad) return false;
  const own = ownDatasources(datasources);
  if (own.length === 0) return false;
  return !own.some((datasource) => datasource.viewerRole === "MEMBER");
}
